import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/Button": Button, "@mui/material/Tooltip": Tooltip } } });
export default ClientProvider;
